import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faBell,
  faSignOut,
  faBrain,
  faGear,
  faTrophy,
  faPeopleGroup,
  faEye,
  faEyeSlash,
  faPen,
  faTrash,
  faAngleLeft,
  faEnvelope,
  faLock,
  faArrowsUpDown,
  faPlus,
  faTimes,
  faToggleOff,
  faMaximize,
  faFilePdf,
  faFile,
  faCircleInfo,
  faHandPointUp,
  faCircleHalfStroke,
  faMoon,
  faList,
  faClipboardList,
  faBars,
  faRotateRight,
  faMinus,
  faBarChart,
} from "@fortawesome/free-solid-svg-icons";



library.add(
  faFile,
  faFilePdf,
  faMaximize,
  faUser,
  faPeopleGroup,
  faBell,
  faHandPointUp,
  faMoon,
  faSignOut,
  faCircleHalfStroke,
  faBrain,
  faGear,
  faTrophy,
  faPeopleGroup,
  faEye,
  faEyeSlash,
  faPen,
  faTrash,
  faAngleLeft,
  faEnvelope,
  faLock,
  faGear,
  faArrowsUpDown,
  faPlus,
  faTimes,
  faToggleOff,
  faCircleInfo,
  faList,
  faClipboardList,
  faBars,
  faRotateRight,
  faMinus,
  faBarChart
);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const workerPdf = require("pdfjs-dist/build/pdf.worker");

let app = createApp(App);
app.config.globalProperties.$APP_URL = "http://127.0.0.1:8000/api/v1";

app
  .use(store)
  .use(router)
  .use(workerPdf)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("Datepicker", Datepicker)
  .mount("#app");
